import * as Yup from 'yup';

export default Yup.object().shape({
  firstName: Yup.string()
    .required('First Name is required')
    .test(
      'is-not-only-spaces',
      'First Name is not valid',
      (value) => !!value && value?.trim().length > 0,
    ),
  lastName: Yup.string()
    .required('Last Name is required')
    .test(
      'is-not-only-spaces',
      'Last Name is not valid',
      (value) => !!value && value?.trim().length > 0,
    ),
  dateOfBirth: Yup.string()
    .matches(
      /^(0[1-9]|1[012])[-]([012][0-9]|3[01])[-]([0-9]{4})$/,
      'Date of birth is not correct',
    )
    .required('Date Of Birth is required'),
  gender: Yup.string().required('Gender is required').nullable(),
  street: Yup.string().required('Street is required').nullable(),
  city: Yup.string().required('City is required').nullable(),
  state: Yup.string().required('State is required').nullable(),
  zip: Yup.string().required('Zip is required').nullable(),
  patientPrimaryPhone: Yup.string()
    .required('Patient primary phone is required')
    .matches(/^[+][0-9]*$/, 'Patient primary phone is not correct'),
  patientSecondaryPhone: Yup.string()
    .matches(/^[+][0-9]*$/, 'Patient secondary phone is not correct')
    .nullable(),
  patientEmail: Yup.string().email('Patient Email is not correct'),
  insurances: Yup.array().of(
    Yup.object().shape({
      insuranceNumber: Yup.string()
        .required('Insurance Number is required')
        .test(
          'is-not-only-spaces',
          'Insurance Number is not valid',
          (value) => !!value && value?.trim().length > 0,
        )
        .nullable(),
      insuranceProvider: Yup.string()
        .required('Insurance Provider is required')
        .test(
          'is-not-only-spaces',
          'Insurance Provider is not valid',
          (value) => !!value && value?.trim().length > 0,
        )
        .nullable(),
      insuranceType: Yup.string().nullable(),
    }),
  ),
  primaryLanguage: Yup.string()
    .required('Preferred Language is required')
    .nullable(),
  race: Yup.string().required('Race is required').nullable(),
  ethnicity: Yup.string().required('Ethnicity is required').nullable(),
  workingStatus: Yup.string().required('Working Status is required').nullable(),
  timeZone: Yup.string().required('Time Zone is required').nullable(),
  maritalStatus: Yup.string().required('Marital Status is required').nullable(),
  physicianFirstName: Yup.string()
    .required('Physician First Name is required')
    .nullable(),
  physicianLastName: Yup.string()
    .required('Physician Last Name is required')
    .nullable(),
  physicianNPI: Yup.string().nullable(),
  emergencyContactCaregiverFirstName: Yup.string()
    .required('Emergency Contact / Caregiver First Name is required')
    .nullable(),
  emergencyContactCaregiverLastName: Yup.string()
    .required('Emergency Contact / Caregiver Last Name is required')
    .nullable(),
  emergencyContactCaregiverPhone: Yup.string()
    .matches(
      /^[+][0-9]*$/,
      'Emergency Contact / Caregiver Phone is not correct',
    )
    .required('Emergency Contact / Caregiver Phone is required')
    .nullable(),
  emergencyContactCaregiverRelationship: Yup.string()
    .required('Emergency Contact / Caregiver Relationship is required')
    .nullable(),

  doYouHaveAnyOfTheseConditions: Yup.array().of(Yup.string()).nullable(),
  doYouAlwaysTakeYourMedicationsAsDirectedByYourPhysician:
    Yup.string().nullable(),
  doYouHaveTroubleGettingYourMedications: Yup.string().nullable(),
  haveYouBeenHospitalizedInTheLast12Months: Yup.string().nullable(),
  haveYouBeenInTheEmergencyRoomInTheLast6Months: Yup.string().nullable(),
  haveYouHadTwoOrMoreFallsInTheLast6Months: Yup.string().nullable(),
  doYouHaveABloodPressureOrGlucometerForPersonalUse: Yup.string().nullable(),
  doYouLiveAlone: Yup.string().nullable(),
  doYouHaveProvider: Yup.string().nullable(),
  whoDoYouRelyOnForTransportation: Yup.string().nullable(),
  doYouHavePowerOfAttorney: Yup.string().nullable(),
  powerOfAttorneyFullNameAndPhoneNumber: Yup.string().nullable(),
  verbalAuthorizationProvidedBy: Yup.string().nullable(),
  verbalAuthorizationDate: Yup.string()
    .matches(
      /^(0[1-9]|1[012])[-]([012][0-9]|3[01])[-]([0-9]{4})$/,
      'Verbal authorization Date is not correct',
    )
    .nullable(),
  verbalAuthorizationTime: Yup.string()
    .matches(
      /^([1-9]|0[1-9]|1[0-2]):[0-5][0-9] ([AP]M)$/,
      'Verbal Authorization Time is not correct',
    )
    .nullable(),
  lastMdVisit: Yup.string()
    .matches(
      /^(0[1-9]|1[012])[-]([012][0-9]|3[01])[-]([0-9]{4})$/,
      'Last Md Visit is not correct',
    )
    .nullable(),

  companyType: Yup.string().nullable(),
  representativeName: Yup.string().nullable(),
  companyNumberCalled: Yup.string().nullable(),
  date: Yup.string()
    .matches(
      /^(0[1-9]|1[012])[-]([012][0-9]|3[01])[-]([0-9]{4})$/,
      'Date is not correct',
    )
    .nullable(),
  time: Yup.string()
    .matches(
      /^([1-9]|0[1-9]|1[0-2]):[0-5][0-9] ([AP]M)$/,
      'Time is not correct',
    )
    .nullable(),
  additionalComments: Yup.string().nullable(),
});
